/**
 * Norlyn a11y (WCAG 4.1.2, 2.5.3, 3.1.2): Finnish accessible names for the Judge.me
 * review widget.
 *
 * The current Judge.me widget (.jm-* classes, rendered with Vue) writes its aria-labels
 * in English even though the store language is Finnish, and the helpful-vote buttons are
 * named "Mark as helpful" while their visible text is the vote count. This script
 * rewrites the labels measured on 15.10.2026. If Judge.me's own text settings
 * (Settings → Language / Text customization) can translate these strings, prefer that
 * and remove the matching rule here.
 *
 * Judge.me re-renders the list when sorting, filtering or loading more, so a
 * MutationObserver re-applies the names. Each rule only writes when the value differs,
 * so the observer does not loop.
 */
(function () {
  'use strict';

  var LABELS = {
    'Close review form': 'Sulje arvostelulomake',
    'Review form pages': 'Arvostelulomakkeen sivut',
    'Review form navigation': 'Arvostelulomakkeen siirtymät',
    'Previous step': 'Edellinen vaihe',
    'Next step': 'Seuraava vaihe',
    'Privacy and Terms': 'Tietosuoja ja ehdot',
    Rating: 'Arvosana',
    'Load More Pagination': 'Lisää arvosteluja',
  };

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function fix(root) {
    // Star rating of a review and of the summary: "5 out of 5 stars" -> "Arvosana 5/5".
    root.querySelectorAll('.jm-star-rating[aria-label]').forEach(function (el) {
      var match = /^([\d.]+) out of (\d+) stars?$/.exec(el.getAttribute('aria-label') || '');
      if (match) setAttr(el, 'aria-label', 'Arvosana ' + match[1].replace('.', ',') + '/' + match[2]);
    });

    // Star buttons in the review form: "1 star", "4 stars" -> "1 tähti", "4 tähteä".
    root.querySelectorAll('button[aria-label]').forEach(function (el) {
      var match = /^(\d) stars?$/.exec(el.getAttribute('aria-label') || '');
      if (match) setAttr(el, 'aria-label', match[1] === '1' ? '1 tähti' : match[1] + ' tähteä');
    });

    // Helpful votes: the visible text is the count, so the name must contain it (2.5.3).
    // The direction is stored on the first pass, because the label is Finnish after it.
    root.querySelectorAll('.jm-voting-controls__button').forEach(function (button) {
      if (!button.dataset.a11yVote) {
        var label = button.getAttribute('aria-label') || '';
        if (/not helpful/i.test(label)) button.dataset.a11yVote = 'down';
        else if (/helpful/i.test(label)) button.dataset.a11yVote = 'up';
        else return;
      }
      var up = button.dataset.a11yVote === 'up';
      var text = up ? 'Arvostelusta oli apua' : 'Arvostelusta ei ollut apua';
      var count = (button.textContent || '').trim();
      var votes = count === '1' ? '1 ääni' : count + ' ääntä';
      setAttr(button, 'aria-label', count ? text + ', ' + votes : text);
      // The icon inside repeats the English label; the button's own name is enough.
      button.querySelectorAll('[role="img"]').forEach(function (icon) {
        setAttr(icon, 'aria-hidden', 'true');
        setAttr(icon, 'aria-label', text);
      });
    });

    root.querySelectorAll('[aria-label]').forEach(function (el) {
      var fi = LABELS[el.getAttribute('aria-label')];
      if (fi) setAttr(el, 'aria-label', fi);
    });

    // Text buttons such as "Show more reviews": the visible text is already Finnish, so the
    // English aria-label only hides it (2.5.3). Drop the label and let the text name it.
    root.querySelectorAll('.jm-button[aria-label]').forEach(function (button) {
      var english = /\b(show|more|reviews?|load|write|filters?|close)\b/i.test(button.getAttribute('aria-label') || '');
      if (english && (button.textContent || '').trim()) button.removeAttribute('aria-label');
    });

    // Sort dropdown: its visually hidden label reads "Sort by".
    root.querySelectorAll('select.jm-sort-filter__select, select.jdgm-sort-dropdown').forEach(function (select) {
      setAttr(select, 'aria-label', 'Lajittele arvostelut');
    });
    root.querySelectorAll('.jm-visually-hidden, [class*="visually-hidden"]').forEach(function (el) {
      if ((el.textContent || '').trim() === 'Sort by') el.textContent = 'Lajittele arvostelut';
    });
  }

  function start() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    fix(widget);
    new MutationObserver(function () {
      fix(widget);
    }).observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
